import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  Exceptiondt2hlxn7j7vw as Exception,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { until1jbpn0z3f8lbg as until } from '../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import {
  captureStack1fzi4aczwc4hg as captureStack,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { get_DefaultSerializersModule10h5j26es502p as get_DefaultSerializersModule } from '../../../../../kiteui-library/com/lightningkite/kiteui/navigation/serialization.mjs';
import { NotImplementedErrorfzlkpv14xxr8 as NotImplementedError } from '../../../../../kotlin-kotlin-stdlib/kotlin/Standard.mjs';
import {
  decodeSerializableValue3h7ajfesxzjda as decodeSerializableValue,
  Decoder23nde051s631g as Decoder,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/encoding/Decoding.mjs';
import { AbstractDecoder35guh02ubh2hm as AbstractDecoder } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/encoding/AbstractDecoder.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function getContextual(_this__u8e3s4, contextualSerializer) {
  try {
    contextualSerializer.deserialize_sy6x50_k$(new (getContextual$1())(_this__u8e3s4));
  } catch ($p) {
    if ($p instanceof DesWrap()) {
      var e = $p;
      var tmp = e.deserializer_1;
      return isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
    } else {
      throw $p;
    }
  }
  throw IllegalStateException().new_kotlin_IllegalStateException_1wtnp1_k$();
}
function enumValues(_this__u8e3s4) {
  var e = new (EnumValueGetter())(0);
  // Inline function 'kotlin.collections.map' call
  var this_0 = until(0, _this__u8e3s4.get_descriptor_wjt6a0_k$().get_elementsCount_288r0x_k$());
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
  var inductionVariable = this_0.first_1;
  var last = this_0.last_1;
  if (inductionVariable <= last)
    do {
      var item = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      e.index_1 = item;
      var tmp$ret$2 = _this__u8e3s4.deserialize_sy6x50_k$(e);
      destination.add_utx5q5_k$(tmp$ret$2);
    }
     while (!(item === last));
  return destination;
}
var DesWrapClass;
function DesWrap() {
  if (DesWrapClass === VOID) {
    class $ extends Exception() {
      constructor(deserializer) {
        return new.target.new_com_lightningkite_kiteui_forms_DesWrap_thzoqa_k$(deserializer);
      }
      static new_com_lightningkite_kiteui_forms_DesWrap_thzoqa_k$(deserializer) {
        var $this = this.new_kotlin_Exception_f32mds_k$();
        captureStack($this, $this.$throwableCtor_2);
        $this.deserializer_1 = deserializer;
        return $this;
      }
    }
    initMetadataForClass($, 'DesWrap');
    DesWrapClass = $;
  }
  return DesWrapClass;
}
var EnumValueGetterClass;
function EnumValueGetter() {
  if (EnumValueGetterClass === VOID) {
    class $ {
      constructor(index) {
        index = index === VOID ? 0 : index;
        this.index_1 = index;
      }
      get_serializersModule_piitvg_k$() {
        return get_DefaultSerializersModule();
      }
      beginStructure_yljocp_k$(descriptor) {
        // Inline function 'kotlin.TODO' call
        var reason = 'Not yet implemented';
        throw NotImplementedError().new_kotlin_NotImplementedError_8rzvsv_k$('An operation is not implemented: ' + reason);
      }
      decodeBoolean_m0aca_k$() {
        // Inline function 'kotlin.TODO' call
        var reason = 'Not yet implemented';
        throw NotImplementedError().new_kotlin_NotImplementedError_8rzvsv_k$('An operation is not implemented: ' + reason);
      }
      decodeByte_jzz7je_k$() {
        // Inline function 'kotlin.TODO' call
        var reason = 'Not yet implemented';
        throw NotImplementedError().new_kotlin_NotImplementedError_8rzvsv_k$('An operation is not implemented: ' + reason);
      }
      decodeChar_dcmcfa_k$() {
        // Inline function 'kotlin.TODO' call
        var reason = 'Not yet implemented';
        throw NotImplementedError().new_kotlin_NotImplementedError_8rzvsv_k$('An operation is not implemented: ' + reason);
      }
      decodeDouble_ur8l0f_k$() {
        // Inline function 'kotlin.TODO' call
        var reason = 'Not yet implemented';
        throw NotImplementedError().new_kotlin_NotImplementedError_8rzvsv_k$('An operation is not implemented: ' + reason);
      }
      decodeEnum_slg6lu_k$(enumDescriptor) {
        return this.index_1;
      }
      decodeFloat_jcnrwu_k$() {
        // Inline function 'kotlin.TODO' call
        var reason = 'Not yet implemented';
        throw NotImplementedError().new_kotlin_NotImplementedError_8rzvsv_k$('An operation is not implemented: ' + reason);
      }
      decodeInline_ux3vza_k$(descriptor) {
        // Inline function 'kotlin.TODO' call
        var reason = 'Not yet implemented';
        throw NotImplementedError().new_kotlin_NotImplementedError_8rzvsv_k$('An operation is not implemented: ' + reason);
      }
      decodeInt_8iq8f5_k$() {
        // Inline function 'kotlin.TODO' call
        var reason = 'Not yet implemented';
        throw NotImplementedError().new_kotlin_NotImplementedError_8rzvsv_k$('An operation is not implemented: ' + reason);
      }
      decodeLong_jzt186_k$() {
        // Inline function 'kotlin.TODO' call
        var reason = 'Not yet implemented';
        throw NotImplementedError().new_kotlin_NotImplementedError_8rzvsv_k$('An operation is not implemented: ' + reason);
      }
      decodeNotNullMark_us4ba1_k$() {
        // Inline function 'kotlin.TODO' call
        var reason = 'Not yet implemented';
        throw NotImplementedError().new_kotlin_NotImplementedError_8rzvsv_k$('An operation is not implemented: ' + reason);
      }
      decodeNull_jzrmuj_k$() {
        // Inline function 'kotlin.TODO' call
        var reason = 'Not yet implemented';
        throw NotImplementedError().new_kotlin_NotImplementedError_8rzvsv_k$('An operation is not implemented: ' + reason);
      }
      decodeShort_jjqk32_k$() {
        // Inline function 'kotlin.TODO' call
        var reason = 'Not yet implemented';
        throw NotImplementedError().new_kotlin_NotImplementedError_8rzvsv_k$('An operation is not implemented: ' + reason);
      }
      decodeString_x3hxsx_k$() {
        // Inline function 'kotlin.TODO' call
        var reason = 'Not yet implemented';
        throw NotImplementedError().new_kotlin_NotImplementedError_8rzvsv_k$('An operation is not implemented: ' + reason);
      }
    }
    protoOf($).decodeSerializableValue_xpnpad_k$ = decodeSerializableValue;
    initMetadataForClass($, 'EnumValueGetter', EnumValueGetter, VOID, [Decoder()]);
    EnumValueGetterClass = $;
  }
  return EnumValueGetterClass;
}
var getContextual$1Class;
function getContextual$1() {
  if (getContextual$1Class === VOID) {
    class $ extends AbstractDecoder() {
      constructor($this_getContextual, $box) {
        if ($box === VOID)
          $box = {};
        $box.$this_getContextual_1 = $this_getContextual;
        super($box);
      }
      get_serializersModule_piitvg_k$() {
        return this.$this_getContextual_1;
      }
      decodeElementIndex_bstkhp_k$(descriptor) {
        return 0;
      }
      decodeSerializableValue_xpnpad_k$(deserializer) {
        throw DesWrap().new_com_lightningkite_kiteui_forms_DesWrap_thzoqa_k$(deserializer);
      }
    }
    initMetadataForClass($);
    getContextual$1Class = $;
  }
  return getContextual$1Class;
}
//region block: exports
export {
  enumValues as enumValues198w9mpbetxy6,
  getContextual as getContextual3ijx86afthbix,
};
//endregion

//# sourceMappingURL=serializerManipulation.mjs.map
